import { api } from "./api";

export interface Certificate {
  _id: string;
  user: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  course: {
    _id: string;
    title: string;
  };
  credentialId: string;
  issuedAt: string;
  expiresAt?: string;
  metadata?: {
    instructorName: string;
    completionDate: string;
    courseDuration: number;
  };
}

export interface CertificateVerification {
  isValid: boolean;
  certificateId: string;
  userName: string;
  courseTitle: string;
  issuedAt: string;
  expiresAt?: string;
}

export const certificateApi = {
  getMyCertificates: () => {
    return api.get<{ success: boolean; data: Certificate[] }>("/certificates/my-certificates");
  },

  getCertificateById: (certificateId: string) => {
    return api.get<{ success: boolean; data: Certificate }>(`/certificates/${certificateId}`);
  },

  getCertificateByCourse: (courseId: string) => {
    return api.get<{ success: boolean; data: Certificate }>(`/certificates/course/${courseId}`);
  },

  verifyCertificate: (credentialId: string) => {
    return api.get<{ success: boolean; data: CertificateVerification }>(`/certificates/verify/${credentialId}`);
  },

  downloadCertificate: (certificateId: string) => {
    return api.get<{ success: boolean; data: { url: string } }>(`/certificates/${certificateId}/download`);
  },

  shareOnLinkedIn: (certificateId: string) => {
    return api.post<{ success: boolean; url: string }>(`/certificates/${certificateId}/share/linkedin`);
  },

  shareOnTwitter: (certificateId: string) => {
    return api.post<{ success: boolean; url: string }>(`/certificates/${certificateId}/share/twitter`);
  },
};